import React, { useEffect, useState } from "react";

const FileViewer = ({ filename, fileURL }) => {
  const [textContent, setTextContent] = useState("");
  const isTextFile = filename.toLowerCase().endsWith(".txt");
  const isPdfFile = filename.toLowerCase().endsWith(".pdf");

  useEffect(() => {
    if (isTextFile) {
      fetch(fileURL)
        .then((res) => res.text())
        .then((text) => setTextContent(text))
        .catch((err) => {
          console.error("Error loading text file:", err);
          setTextContent("Failed to load file content.");
        });
    }
  }, [fileURL, isTextFile]);

  return isTextFile ? (
    <pre style={{ overflow: "auto", height: "100%" }}>{textContent}</pre>
  ) : isPdfFile ? (
    <iframe
      src={fileURL}
      style={{ width: "100%", height: "100%", border: "none" }}
      title="File Viewer"
    ></iframe>
  ) : (
    <iframe
      src={`https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
        fileURL,
      )}&wdHideGridlines=true&wdHideHeadersFooters=true`}
      style={{ width: "100%", height: "100%", border: "none" }}
      title="Document Preview"
      aria-label="Document viewer"
      role="document"
    />
  );
};

export default FileViewer;
